import { Spinner } from 'reactstrap'

import UnauthenticatedLayout, { UNAUTHENTICATED_BACKGROUND_KEYS } from 'components/UnauthenticatedLayout'
import ScribbleBackground from 'components/ScribbleBackground'

import { ScreenContainer, SpinnerContainer } from './styles'

const SpinnerScreen = () => (
  <ScreenContainer>
    <UnauthenticatedLayout backgroundKey={UNAUTHENTICATED_BACKGROUND_KEYS.peopleWithLogo}>
      <ScribbleBackground>
        <SpinnerContainer>
          <Spinner data-testid="root-auth-initialize-spinner" />
        </SpinnerContainer>
      </ScribbleBackground>
    </UnauthenticatedLayout>
  </ScreenContainer>
)

export default SpinnerScreen
